import Call from '../../Call';

const Partners = {
    get() {
        return Call(`adkBanner/partners`);
    },

    save(feed) {
        return Call('adkBanner/partners','POST', feed);
    },

    remove(id) {
        return Call(`adkBanner/partners/${id}`,'DELETE');
    }
};

export default Partners;


// WEBPACK FOOTER //
// ./src/services/API/components/AdkBanner/Partners.js